import { render, staticRenderFns } from "./CtaAnfitriao.vue?vue&type=template&id=d6b90b96&scoped=true"
import script from "./CtaAnfitriao.vue?vue&type=script&lang=js"
export * from "./CtaAnfitriao.vue?vue&type=script&lang=js"
import style0 from "./CtaAnfitriao.vue?vue&type=style&index=0&id=d6b90b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b90b96",
  null
  
)

export default component.exports